/**
 * @generated SignedSource<<83d2e2b346975f94ed7562ce707a2991>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getHasEnoughSimilarSoldItems_viewer$data = {
  readonly similarSoldItemsResults?: {
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentType": "getHasEnoughSimilarSoldItems_viewer";
};
export type getHasEnoughSimilarSoldItems_viewer$key = {
  readonly " $data"?: getHasEnoughSimilarSoldItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"getHasEnoughSimilarSoldItems_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getHasEnoughSimilarSoldItems_viewer"
};

(node as any).hash = "2fdcbc6320560444a0e55cd6928039b0";

export default node;
